export const LOAD_TERMINAL_SERVICES_CONFIG_REQUESTED = '@terminal-services/services/LOAD_TERMINAL_SERVICES_CONFIG_REQUESTED';



// WEBPACK FOOTER //
// ./src/modules/services/actionTypes.js